module.exports = __webpack_public_path__ + "img/rotateHint_CH.2850d50e.png";